export default {
  lang: {
    confirm: {
      title: "Sei sicuro di volerlo eliminare? Non è possibile ripristinarlo dopo l'eliminazione",
      okText: 'Elimina',
      cancelText: 'Annulla',
    },
  },
};
